import { format } from '@bilibili-maoer/web-utils'

import { useState } from 'react'

import { Stack } from '@mui/material'
import moment from 'moment'
import useMount from 'react-use/esm/useMount'

import { forceFormatNumberWith } from '~/core/utils/number'
import { DataBlock } from '~/features/guild/components/data-block'
import { DataBlocksTitle, GuildTitle } from '~/features/guild/components/title'
import { GuildReportInfoLineCharts } from '~/features/guild/report/component/report-info-charts'
import { GUILD_STREAMER_OVERVIEW_DATA_DEFINITIONS } from '~/features/guild/report/constants'
import { GuildDataBlock } from '~/features/guild/types'
import { ROOM_REPORT_INFO_MENU_FIELD_MAP_DATA_ITEM_FIELD } from '~/features/room/report/constants'
import { RoomReportInfoMenu } from '~/features/room/report/types'
import { RoomApi } from '~/services/fm/room'
import { MilliSeconds } from '~/shared/types/base/units'

const DATA_BLOCKS: GuildDataBlock<RoomReportInfoMenu>[] = [
  {
    field: 'total_live_duration',
    title: '直播时长',
    render: (menu) =>
      menu && menu.total_live_duration
        ? format.formatDuration(menu.total_live_duration * 60 * 1000, 'zh')
        : format.formatDuration(0, 'zh'),
  },
  {
    field: 'new_fans_num',
    title: '新增粉丝数',
  },
  {
    field: 'total_listener_duration_avg',
    title: '人均收听时长（分钟）',
  },
  {
    field: 'listener_duration_more_than_five_minutes_ratio',
    title: '超 5 分钟收听占比',
    render: (menu) =>
      menu && menu.listener_duration_more_than_five_minutes_ratio
        ? `${menu.listener_duration_more_than_five_minutes_ratio}%`
        : forceFormatNumberWith(0),
  },
]

export const GuildReportInfo = (props: { startTime: MilliSeconds; endTime: MilliSeconds; liveId: number }) => {
  const [selectedDataBlockField, setSelectedDataBlockField] = useState<keyof RoomReportInfoMenu>('total_live_duration')

  const getReportInfoQueryParams = {
    creator_id: props.liveId,
    start_date: moment(props.startTime).format('YYYY-MM-DD'),
    end_date: moment(props.endTime).format('YYYY-MM-DD'),
  }

  const {
    data: reportInfoData,
    refetch: refetchReportData,
    isLoading,
  } = RoomApi.getReportInfo.useQuery(getReportInfoQueryParams)

  useMount(() => {
    refetchReportData()
  })

  return (
    <>
      <Stack spacing={2}>
        <DataBlocksTitle>
          <GuildTitle
            title="主播数据概况"
            tooltipTitle="指标定义"
            tooltipContents={GUILD_STREAMER_OVERVIEW_DATA_DEFINITIONS}
          />
        </DataBlocksTitle>
        <div>
          {DATA_BLOCKS.map((block) => {
            const fieldName = block.field as keyof RoomReportInfoMenu
            return (
              <DataBlock
                key={block.field}
                title={block.title}
                content={
                  block.render
                    ? block.render(reportInfoData?.menu)
                    : forceFormatNumberWith(reportInfoData?.menu?.[fieldName])
                }
                selectable
                active={selectedDataBlockField === block.field}
                handleClick={() => setSelectedDataBlockField(block.field)}
              />
            )
          })}
        </div>
        <GuildReportInfoLineCharts
          chartData={reportInfoData?.data || []}
          activeChartField={ROOM_REPORT_INFO_MENU_FIELD_MAP_DATA_ITEM_FIELD[selectedDataBlockField]}
          startTime={props.startTime}
          endTime={props.endTime}
          loading={isLoading}
        />
      </Stack>
    </>
  )
}
